const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));

function getPluginName(ast, name) {
  console.log('pluginName=', `$${name}${camelize(`-${ast}`)}Plugin`);
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}

const astPlugin = {
  install(Vue) {
    Vue.prototype.$ast = {
      // entry_point

      entryPoint: async (meta) => {
        console.info('entryPoint');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].entryPoint) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].entryPoint(meta);
        }
      },
      // share
      initShare: async (shareConfig) => {
        console.info('initShare shareConfig=', shareConfig);
        // APP环境
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')]
          && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].isAPP
          && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].isAPP()
          && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].initAPPShare) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].initAPPShare(shareConfig);
        } else {
          const shareWxAppid = Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].getAstConfig
            && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].getAstConfig()
            && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].getAstConfig().shareWxAppId;
          console.log('initShare shareWxAppid = ', shareWxAppid);
          window.TGMobileShare({
            shareTitle: shareConfig.title, // 不设置或设置为空时，页面有title，则调取title
            shareDesc: shareConfig.desc, // 不设置或设置为空时，页面有Description，则调取Description
            shareImgUrl: shareConfig.icon, // 分享图片尺寸200*200，且填写绝对路径
            shareLink: shareConfig.link || window.location.href, // 分享链接要跟当前页面同域名(手Q分享有这个要求) ,不设置或设置为空时，默认调取当前URL
            actName: `ceiba_${Vue.prototype.$actInfo.activity_id}`, // 点击流命名，用于统计分享量，专题一般采用目录名称如a20151029demo
            wxAppId: shareWxAppid ? shareWxAppid : undefined, // 微信公众号appid， 微信分享QQ的时候会用到
          });
        }
      },
      setAPPShare: async (params) => {
        console.info('setAPPShare params=', params);
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].setAPPShare) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].setAPPShare(params);
        }
      },
      goAPPShare: async () => {
        console.info('goAPPShare');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].goAPPShare) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].goAPPShare();
        }
      },
      disableAPPShare: async () => {
        console.info('disableAPPShare');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].disableAPPShare) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].disableAPPShare();
        }
      },
      // app
      isAPP: () => {
        console.info('isAPP');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].isAPP) {
          return Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].isAPP();
        }
        return true;
      },
      gotoAPP: async (link) => {
        console.info('gotoAPP');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].gotoAPP) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].gotoAPP(link);
        }
      },
      openView: async (params) => {
        console.info('openView');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].openView) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].openView(params);
        } else {
          window.location.href = params.url;
        }
      },
      doHook: async (name, options) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].hooks && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].hooks[name]) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].hooks[name](options);
        }
      },
      getFlowRequestExtData: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].getFlowRequestExtData) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].getFlowRequestExtData(params);
        }
        return {};
      },
    };
  },
};

export default astPlugin;
